<section class="contacts container" *ngIf="data.contacts && data.contacts.length > 0">
  
  <h2>Profissionais</h2>

  <table>

    <tr>
      <th>Profissional</th>
      <th class="job">Tipo de profissional</th>
      <th>Contato</th>
    </tr>

    <tr *ngFor="let contact of data.contacts; let i = index">
      <ng-container  *ngIf="contact.title !== 'Proprietário' && contact.title !== 'proprietário' && (contact.phone_number || contact.email)">

        <td>
          {{contact.name | titlecase}}
          <ng-container *ngIf="contact.super">({{contact.super | titlecase}})</ng-container>
          <ng-container *ngIf="contact.company_name">- {{contact.company_name | titlecase}}</ng-container>
        </td>
  
        <td class="job">
          {{contact.title}}
        </td>
  
        <td>
          
          <a *ngIf="contact.phone_number" id="phone-button-{{i}}" class="data button phone"
            matTooltip="{{contact.area_code +' '+ contact.phone_number}}"
            (click)="geralService.copyToClipboard(contact.area_code +' '+ contact.phone_number); snackService.show('Telefone copiado');">
            {{contact.area_code}}
            <ng-container *ngIf="contact.phone_number.length >= 9">
              {{contact.phone_number | mask:'00000 0000'}}
            </ng-container>
            <ng-container *ngIf="contact.phone_number.length < 9">
              {{contact.phone_number | mask:'0000 0000'}}
            </ng-container>
          </a>
  
          <a *ngIf="contact.email" id="email-button-{{i}}" class="data button email"
            matTooltip="{{contact.email}}"
            (click)="geralService.copyToClipboard(contact.email); snackService.show('Email copiado');">
            {{contact.email}}
          </a>
  
        </td>

      </ng-container>
    </tr>

  </table>
</section>

<section class="contacts container" *ngIf="data.contact_owner && data.contact_owner.length > 0">

  <h2>Proprietários</h2>

  <table>
    <tr>
      <th>Proprietário</th>
      <th>Contato</th>
    </tr>

    <tr *ngFor="let contact of data.contact_owner; let i = index">
      <td>
        {{contact.name | titlecase}}
      </td>

      <td>
        <a *ngIf="contact.phone_number" id="phone-button-{{i}}" class="data button phone"
          matTooltip="{{contact.area_code +' '+ contact.phone_number}}"  
          (click)="geralService.copyToClipboard(contact.area_code +' '+ contact.phone_number); snackService.show('Telefone copiado');">
          {{contact.area_code}}
          <ng-container *ngIf="contact.phone_number.length >= 9">
            {{contact.phone_number | mask:'00000 0000'}}
          </ng-container>
          <ng-container *ngIf="contact.phone_number.length < 9">
            {{contact.phone_number | mask:'0000 0000'}}
          </ng-container>
        </a>

        <a *ngIf="contact.email" id="email-button-{{i}}" class="data button email"
          matTooltip="{{contact.email}}"  
          (click)="geralService.copyToClipboard(contact.email); snackService.show('Email copiado');">
          {{contact.email}}
        </a>
      </td>

    </tr>

  </table>
</section>